import React from 'react'
import { MainView } from './components'

const App = () => {
  return (
    <div className="container">
      <MainView />
    </div>
  )
}

export default App
